/**
 * @fileoverview Contrato del cliente de CR Auth (is-cr-zonasegura-platform-api-auth).
 * CR Auth se llama directo, sin Apigee: `logout` lee `Authorization` y su CORS acepta `*`.
 * @module integrations/auth.integration
 */

import { createAuthIntegration } from './impl/auth.integration.impl'

/**
 * @typedef {import('./models/auth.models').LoginRequest} LoginRequest
 * @typedef {import('./models/auth.models').LoginResponse} LoginResponse
 * @typedef {import('./models/auth.models').SessionTokens} SessionTokens
 * @typedef {import('./models/auth.models').OtpRequest} OtpRequest
 * @typedef {import('./models/auth.models').OtpResendRequest} OtpResendRequest
 * @typedef {import('./models/auth.models').OtpVerifyRequest} OtpVerifyRequest
 * @typedef {import('./models/auth.models').OtpChallenge} OtpChallenge
 * @typedef {import('./models/auth.models').OtpVerificationResult} OtpVerificationResult
 */

/**
 * Contrato del cliente de CR Auth. Todas las operaciones rechazan con un IntegrationError.
 * @typedef {Object} AuthIntegration
 * @property {function(LoginRequest): Promise<LoginResponse>} login - POST auth/login
 * @property {function(OtpRequest): Promise<OtpChallenge>} signup - POST auth/signup
 * @property {function(OtpRequest): Promise<OtpChallenge>} passwordRecovery - POST auth/password/recovery (siempre 202)
 * @property {function(OtpResendRequest): Promise<OtpChallenge>} otpResend - POST auth/otp/resend
 * @property {function(OtpVerifyRequest): Promise<OtpVerificationResult>} otpVerify - POST auth/otp/verify
 * @property {function(string): Promise<SessionTokens>} refresh - POST auth/token/refresh (rota el refresh token)
 * @property {function(string): Promise<void>} logout - POST auth/logout con el access token
 */

/** @type {AuthIntegration} */
const authIntegration = createAuthIntegration()

export default authIntegration



// WEBPACK FOOTER //
// ./src/integrations/auth.integration.js